export default __webpack_public_path__ + "static/media/new 404.532414ff.svg";